<div class="no-data-sec">
    <div class="container text-center d-flex align-items-center justify-content-center">
        <div class="py-5 px-3">
            <h1  class="heading-one">{{message}}</h1>
            <p class="description paragraph-global-text" *ngIf="description">{{description}}</p>
        </div>        
    </div>
</div>
